module.exports = __webpack_public_path__ + "img/img_info.e15100be.png";